import { render, staticRenderFns } from "./netValue.html?vue&type=template&id=137f34f2&scoped=true&"
import script from "./netValue.ts?vue&type=script&lang=ts&"
export * from "./netValue.ts?vue&type=script&lang=ts&"
import style0 from "./netValue.scss?vue&type=style&index=0&id=137f34f2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "137f34f2",
  null
  
)

export default component.exports